import { Pipe, PipeTransform } from '@angular/core';

const SECONDS_PER_MINUTE = 60;
const TIME_FORMAT_PADDING = 2;

@Pipe({
  name: 'formatTime',
  standalone: true,
})
export class FormatTimePipe implements PipeTransform {
  transform(time: number): string {
    if (!time) {
      return '00:00';
    }

    const minutes = Math.floor(time / SECONDS_PER_MINUTE);
    const seconds = Math.floor(time % SECONDS_PER_MINUTE);

    return `${minutes.toString().padStart(TIME_FORMAT_PADDING, '0')}:${seconds.toString().padStart(TIME_FORMAT_PADDING, '0')}`;
  }
}
